import { format } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import useAuthRequest from "../../../utils/useAuthRequest";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import "./LegacySpinnerStyling.css";
import MoonLoader from "react-spinners/MoonLoader";
import { useOrdersShop } from "../../helper/OrderWebshopContext";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";
import axios from "axios";
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";

type WebshopProduct = {
  id: string;
  articleNr: number;
  ean: string;
  name: string;
  salesText: string;
  price: number;
  quantity: number;
  mainImage?: string;
};

type WebshopOrder = {
  orderId: string;
  orderNumber: string;
  products: WebshopProduct[];
  totalAmount: number;
  status: string;
  vorkasse: boolean;
  createdAt: Date;
  deliveryAddress: string;
  billingAddress?: string;
};

interface OrderCardWebshopProps {
  order: WebshopOrder;
  onPackOrderShop?: (orderId: string) => void;
  onShipOrder?: (orderId: string) => void;
  onCompleteOrder?: (orderId: string) => void;
  onReturnOrder?: (orderID: string) => void;
  onDenyReturn?: (orderID: string, reason: string, condition: string) => void;
  isLoadingPick?: boolean;
  isLoadingPack?: boolean;
  isLoadingPickUp?: boolean;
}

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

const OrderCardWebshop: React.FC<OrderCardWebshopProps> = ({
  order,
  onPackOrderShop,
  onShipOrder,
  onCompleteOrder,
  onReturnOrder,
  onDenyReturn,
  isLoadingPick,
  isLoadingPack,
  isLoadingPickUp,
}) => {
  const [isLoadingRevert, setIsLoadingRevert] = useState(false);
  const formattedDate = format(
    new Date(order.createdAt.toString()),
    "dd.MM.yyyy HH:mm"
  );
  const modalRef = useRef<HTMLDivElement>(null);
  const modalAcceptRef = useRef<HTMLDivElement>(null);
  const modalReturnDenyRef = useRef<HTMLDivElement>(null);
  const toastRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const { fetchOrdersShop } = useOrdersShop();
  const sendRequest = useAuthRequest();
  const [selectedReason, setSelectedReason] = useState("");
  const [selectedCondition, setSelectedCondition] = useState("");

  const handlePrintLabel = async (orderId: string) => {
    try {
      const response = await sendRequest(
        `/api/dhl/createOneWayShipment/${orderId}`,
        "post"
      );
      if (response.status === 200) {
        const pdfBlob = b64toBlob(
          response.data.dataUri.split(",")[1],
          "application/pdf"
        );
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, "_blank");
      } else {
        console.error("Fehler beim Erhalten des Labels");
      }
    } catch (error) {
      console.error("Fehler beim Erstellen des DHL-Labels für Webshop:", error);
    }
  };

  const handleGenerateNotes = async () => {
    const databaseOrderId = order.orderId;
    try {
      const deliveryNoteResponse = await sendRequest(
        `/api/pdf/webshop/invoice/${databaseOrderId}`,
        "get",
        { responseType: "blob" }
      );
      if (deliveryNoteResponse.status === 200) {
        const byteArray = new Uint8Array(
          Object.values(deliveryNoteResponse.data)
        );
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const deliveryNoteUrl = URL.createObjectURL(blob);
        window.open(deliveryNoteUrl, "_blank");
      } else {
        console.error("Fehler beim Erhalten des Lieferscheins");
      }

      //Hier Rechnungserstellung einbinden
      const returnNoteResponse = await sendRequest(
        `/api/pdf/webshop/delivery-note/${databaseOrderId}`,
        "get",
        { responseType: "blob" }
      );
      if (returnNoteResponse.status === 200) {
        const byteArray = new Uint8Array(
          Object.values(returnNoteResponse.data)
        );
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const returnNoteUrl = URL.createObjectURL(blob);
        window.open(returnNoteUrl, "_blank");
      } else {
        console.error("Fehler beim Erhalten des Retourenscheins");
      }
    } catch (error) {
      console.error("Fehler bei der Erzeugung der PDFs:", error);
    }
  };

  const handleCancelOrderShop = async (orderId: string) => {
    try {
      const response = await sendRequest<{ newStatus: string }>(
        `/api/webshop/order/${orderId}/status`,
        "patch",
        { newStatus: "canceled" }
      );
      if (response.status === 200) {
        fetchOrdersShop("pending");
        fetchOrdersShop("canceled");
        fetchOrdersShop("picked");
        fetchOrdersShop("packed");
        fetchOrdersShop("sent");
      } else {
        throw new Error("Fehler beim Aktualisieren des Bestellstatus");
      }

      console.log("Antwort von der API:", response.data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Fehlerdetails:",
          error.response?.data || error.message
        );
      } else {
        console.error("Ein unerwarteter Fehler ist aufgetreten:", error);
      }
    }
  };

  function b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  const openModal = () => {
    if (modalRef.current) {
      modalRef.current.classList.remove("hidden");
    }
  };
  const closeModal = () => {
    if (modalRef.current) {
      modalRef.current.classList.add("hidden");
    }
  };
  const openModalAccept = () => {
    if (modalAcceptRef.current) {
      modalAcceptRef.current.classList.remove("hidden");
    }
  };
  const closeModalAccept = () => {
    if (modalAcceptRef.current) {
      modalAcceptRef.current.classList.add("hidden");
    }
  };
  const openModalReturnDeny = () => {
    if (modalReturnDenyRef.current) {
      modalReturnDenyRef.current.classList.remove("hidden");
    }
  };
  const closeModalReturnDeny = () => {
    if (modalReturnDenyRef.current) {
      modalReturnDenyRef.current.classList.add("hidden");
    }
  };
  const toggleToast = () => {
    if (toastRef.current) {
      toastRef.current.classList.toggle("hidden");
    }
  };

  const handleCompleteAndClose = () => {
    if (onCompleteOrder) {
      onCompleteOrder(order.orderId);
    }
    closeModalAccept();
  };
  const handleReturnDenyAndClose = () => {
    if (onDenyReturn) {
      onDenyReturn(order.orderId, selectedReason, selectedCondition);
    }
    closeModalReturnDeny();
  };
  function calculateQuantity(currentOrder: WebshopOrder) {
    let quant = 0;
    currentOrder.products.forEach((element) => {
      quant += element.quantity;
    });
    return quant;
  }
  const handleMoveOrderToPending = async (orderId: string) => {
    setIsLoadingRevert(true);
    try {
      const response = await sendRequest<{ newStatus: string }>(
        `/api/webshop/order/${orderId}/status`,
        "patch",
        { newStatus: "pending" }
      );
      if (response.status === 200) {
        fetchOrdersShop("pending");
        fetchOrdersShop("picked");
        fetchOrdersShop("packed");
        fetchOrdersShop("sent");
      } else {
        throw new Error("Fehler beim Aktualisieren des Bestellstatus");
      }
    } catch (error) {
      console.error("Fehler beim Aktualisieren des Bestellstatus:", error);
    } finally {
      setIsLoadingRevert(false);
    }
  };

  const getUniqueProductsByEAN = (products: WebshopProduct[]) => {
    const uniqueProducts: WebshopProduct[] = [];
    const productCounts: Record<string, number> = {}; // Speichert die Anzahl der Vorkommen jedes EAN

    products.forEach((product) => {
      // Prüft, ob der EAN bereits gesehen wurde und zählt die Vorkommen
      if (productCounts[product.ean]) {
        productCounts[product.ean] += 1; // Erhöht die Anzahl, wenn schon vorhanden
      } else {
        productCounts[product.ean] = 1; // Initialisiert mit 1 beim ersten Vorkommen
        uniqueProducts.push(product); // Fügt das Produkt beim ersten Vorkommen hinzu
      }
    });

    // Ergänze jedes Produkt in uniqueProducts um die Anzahl seiner Vorkommen
    uniqueProducts.forEach((product) => {
      product.quantity = productCounts[product.ean];
    });

    return uniqueProducts;
  };

  const handleSelectCondition = (reason: string) => {
    setSelectedCondition(reason);
  };

  const handleSelectReason = (reason: string) => {
    setSelectedReason(reason);
  };

  function formatPrice(priceString: string): string {
    let price = parseFloat(priceString.replace(",", "."));

    let formattedPrice = price.toFixed(2);

    return formattedPrice
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  const renderButtons = () => {
    if (location.pathname === "/webshop/eingang") {
      return (
        <div className="flex items-center justify-center gap-2">
          {order.vorkasse && (
            <Dialog>
              <DialogTrigger asChild>
                <button
                  className="flex items-center justify-center text-gray-50 bg-blue-400 dark:bg-sidebarGray-700 hover:bg-blue-500 dark:hover:bg-sidebarGray-500 rounded-lg py-1 px-4 gap-2 disabled:text-sidebarGray-400"
                >
                  <ExclamationTriangleIcon />
                  <p className="text-base">Bestellung stornieren</p>
                </button>
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Bestellung stornieren</DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                  <p>Möchten Sie diese Bestellung wirklich stornieren? Diese Aktion kann nicht rückgängig gemacht werden.</p>
                </div>
                <DialogFooter>
                  <DialogClose asChild>
                    <Button type="button" variant="secondary">
                      Schließen
                    </Button>
                  </DialogClose>
                  <Button variant="destructive" onClick={() => handleCancelOrderShop(order.orderId)} disabled={isLoadingPick}>
                    {isLoadingPick ? <MoonLoader size={15} /> : "Ja, stornieren"}
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          )}
          <button
            onClick={() => onPackOrderShop && onPackOrderShop(order.orderId)}
            disabled={isLoadingPick}
            className="flex items-center justify-center text-gray-50 bg-blue-400 dark:bg-sidebarGray-700 hover:bg-blue-500 dark:hover:bg-sidebarGray-500 rounded-lg py-1 px-4 gap-2 disabled:text-sidebarGray-400"
          >
            {isLoadingPick ? (
              <MoonLoader color="rgba(215, 215, 215, 1)" size={15} />
            ) : (
              <svg
                width="20"
                height="20"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z"
                  fill="currentColor"
                  fillRule="evenodd"
                  clipRule="evenodd"
                ></path>
              </svg>
            )}
            <p className="text-base">Bestellung picken</p>
          </button>
        </div>
      );
    } else if (location.pathname === "/webshop/gepickt") {
      return (
        <div className="flex items-center justify-center gap-4">
          <button
            onClick={() => handleGenerateNotes()}
            className="flex items-center justify-center text-gray-50 bg-blue-400 dark:bg-sidebarGray-700 hover:bg-blue-500 dark:hover:bg-sidebarGray-500 rounded-lg py-1 px-4 gap-2"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.2 1H4.17741H4.1774C3.86936 0.999988 3.60368 0.999978 3.38609 1.02067C3.15576 1.04257 2.92825 1.09113 2.71625 1.22104C2.51442 1.34472 2.34473 1.51442 2.22104 1.71625C2.09113 1.92825 2.04257 2.15576 2.02067 2.38609C1.99998 2.60367 1.99999 2.86935 2 3.17738V3.1774V3.2V11.8V11.8226V11.8226C1.99999 12.1307 1.99998 12.3963 2.02067 12.6139C2.04257 12.8442 2.09113 13.0717 2.22104 13.2837C2.34473 13.4856 2.51442 13.6553 2.71625 13.779C2.92825 13.9089 3.15576 13.9574 3.38609 13.9793C3.60368 14 3.86937 14 4.17741 14H4.2H10.8H10.8226C11.1306 14 11.3963 14 11.6139 13.9793C11.8442 13.9574 12.0717 13.9089 12.2837 13.779C12.4856 13.6553 12.6553 13.4856 12.779 13.2837C12.9089 13.0717 12.9574 12.8442 12.9793 12.6139C13 12.3963 13 12.1306 13 11.8226V11.8V3.2V3.17741C13 2.86936 13 2.60368 12.9793 2.38609C12.9574 2.15576 12.9089 1.92825 12.779 1.71625C12.6553 1.51442 12.4856 1.34472 12.2837 1.22104C12.0717 1.09113 11.8442 1.04257 11.6139 1.02067C11.3963 0.999978 11.1306 0.999988 10.8226 1H10.8H4.2ZM3.23875 2.07368C3.26722 2.05623 3.32362 2.03112 3.48075 2.01618C3.64532 2.00053 3.86298 2 4.2 2H10.8C11.137 2 11.3547 2.00053 11.5193 2.01618C11.6764 2.03112 11.7328 2.05623 11.7613 2.07368C11.8285 2.11491 11.8851 2.17147 11.9263 2.23875C11.9438 2.26722 11.9689 2.32362 11.9838 2.48075C11.9995 2.64532 12 2.86298 12 3.2V11.8C12 12.137 11.9995 12.3547 11.9838 12.5193C11.9689 12.6764 11.9438 12.7328 11.9263 12.7613C11.8851 12.8285 11.8285 12.8851 11.7613 12.9263C11.7328 12.9438 11.6764 12.9689 11.5193 12.9838C11.3547 12.9995 11.137 13 10.8 13H4.2C3.86298 13 3.64532 12.9995 3.48075 12.9838C3.32362 12.9689 3.26722 12.9438 3.23875 12.9263C3.17147 12.8851 3.11491 12.8285 3.07368 12.7613C3.05624 12.7328 3.03112 12.6764 3.01618 12.5193C3.00053 12.3547 3 12.137 3 11.8V3.2C3 2.86298 3.00053 2.64532 3.01618 2.48075C3.03112 2.32362 3.05624 2.26722 3.07368 2.23875C3.11491 2.17147 3.17147 2.11491 3.23875 2.07368ZM5 10C4.72386 10 4.5 10.2239 4.5 10.5C4.5 10.7761 4.72386 11 5 11H8C8.27614 11 8.5 10.7761 8.5 10.5C8.5 10.2239 8.27614 10 8 10H5ZM4.5 7.5C4.5 7.22386 4.72386 7 5 7H10C10.2761 7 10.5 7.22386 10.5 7.5C10.5 7.77614 10.2761 8 10 8H5C4.72386 8 4.5 7.77614 4.5 7.5ZM5 4C4.72386 4 4.5 4.22386 4.5 4.5C4.5 4.77614 4.72386 5 5 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H5Z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
              ></path>
            </svg>
            <p className="text-base">Lieferschein / Rechnung</p>
          </button>
          <button
            onClick={() => handlePrintLabel(order.orderId)}
            className="flex items-center justify-center text-gray-50 bg-blue-400 dark:bg-sidebarGray-700 hover:bg-blue-500 dark:hover:bg-sidebarGray-500 rounded-lg py-1 px-4 gap-2"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 11.0001V4.00006L1 4.00006L1 11.0001H14ZM15 4.00006V11.0001C15 11.5523 14.5523 12.0001 14 12.0001H1C0.447715 12.0001 0 11.5523 0 11.0001V4.00006C0 3.44778 0.447715 3.00006 1 3.00006H14C14.5523 3.00006 15 3.44778 15 4.00006ZM2 5.25C2 5.11193 2.11193 5 2.25 5H5.75C5.88807 5 6 5.11193 6 5.25V9.75C6 9.88807 5.88807 10 5.75 10H2.25C2.11193 10 2 9.88807 2 9.75V5.25ZM7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H7.5ZM7 9.5C7 9.22386 7.22386 9 7.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H7.5C7.22386 10 7 9.77614 7 9.5ZM7.5 5C7.22386 5 7 5.22386 7 5.5C7 5.77614 7.22386 6 7.5 6H11.5C11.7761 6 12 5.77614 12 5.5C12 5.22386 11.7761 5 11.5 5H7.5Z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
              ></path>
            </svg>
            <p className="text-base">Paketlabel erzeugen</p>
          </button>
          {order.status === "picked" && (
            <button
              onClick={() => onShipOrder && onShipOrder(order.orderId)}
              disabled={isLoadingPack}
              className="flex items-center justify-center text-gray-50 bg-blue-400 dark:bg-sidebarGray-700 hover:bg-blue-500 dark:hover:bg-sidebarGray-500 rounded-lg py-1 px-4 gap-2 disabled:text-sidebarGray-500"
            >
              {isLoadingPack ? (
                <MoonLoader color="rgba(215, 215, 215, 1)" size={15} />
              ) : (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z"
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  ></path>
                </svg>
              )}
              <p className="text-base">Abholung</p>
            </button>
          )}
        </div>
      );
    } else if (location.pathname === "/webshop/verpackt") {
      return (
        <div className="flex items-center justify-center gap-4">
          <button
            onClick={openModalAccept}
            className="flex items-center justify-center text-gray-50 bg-blue-400 dark:bg-sidebarGray-700 hover:bg-blue-500 dark:hover:bg-sidebarGray-500 rounded-lg py-1 px-4 gap-2"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
              ></path>
            </svg>
            <p className="text-base">Bestellung abschließen</p>
          </button>
        </div>
      );
    } else if (location.pathname === "/webshop/retouren") {
      return (
        <div className="flex items-center justify-center gap-4">
          <button
            onClick={() => onReturnOrder?.(order.orderId)}
            className="flex items-center justify-center text-gray-50 bg-blue-400 dark:bg-sidebarGray-700 hover:bg-blue-500 dark:hover:bg-sidebarGray-500 rounded-lg py-1 px-4 gap-2"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
              ></path>
            </svg>
            <p className="text-base">Retoure bestätigen</p>
          </button>
          <button
            onClick={openModalReturnDeny}
            className="flex items-center justify-center text-gray-50 bg-blue-400 dark:bg-sidebarGray-700 hover:bg-blue-500 dark:hover:bg-sidebarGray-500 rounded-lg py-1 px-4 gap-2"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704ZM9.85358 5.14644C10.0488 5.3417 10.0488 5.65829 9.85358 5.85355L8.20713 7.49999L9.85358 9.14644C10.0488 9.3417 10.0488 9.65829 9.85358 9.85355C9.65832 10.0488 9.34173 10.0488 9.14647 9.85355L7.50002 8.2071L5.85358 9.85355C5.65832 10.0488 5.34173 10.0488 5.14647 9.85355C4.95121 9.65829 4.95121 9.3417 5.14647 9.14644L6.79292 7.49999L5.14647 5.85355C4.95121 5.65829 4.95121 5.3417 5.14647 5.14644C5.34173 4.95118 5.65832 4.95118 5.85358 5.14644L7.50002 6.79289L9.14647 5.14644C9.34173 4.95118 9.65832 4.95118 9.85358 5.14644Z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
              ></path>
            </svg>
            <p className="text-base">Retoure ablehnen</p>
          </button>
        </div>
      );
    }
  };
  const uniqueProducts = getUniqueProductsByEAN(order.products);

  return (
    <div className="w-full bg-sidebarGrayLight-400 dark:bg-sidebarGray-800 rounded-xl">
      <div className="relative flex items-start justify-start gap-4">
        <div className="relative flex flex-col justify-between items-start w-[400px] border-sidebarGrayLight-800 dark:border-sidebarGray-700 border-r-[1px] p-6">
          <div className="relative flex flex-col gap-2">
            <div className="flex flex-col">
              <span className="text-sm text-gray-500">Bestellnummer: </span>
              <span className="text-3xl">{order.orderNumber}</span>
            </div>
            <div className="flex flex-col">
              <span className="text-sm text-gray-500">Bestellte Artikel: </span>
              <span className="text-base">
                {`${calculateQuantity(order)}`}&nbsp;Artikel
              </span>
            </div>
            <div className="flex flex-col">
              <span className="text-sm text-gray-500">Gesamtpreis: </span>
              <span className="text-base">
                {formatPrice(order.totalAmount.toString())}€
              </span>
            </div>
            <div className="flex flex-col">
              <span className="text-sm text-gray-500">
                Bestelldatum/-zeit:{" "}
              </span>
              <span className="text-base">{formattedDate}</span>
            </div>
          </div>
          <div className="relative h-full">
            <div className="flex flex-col gap-2">
              {order.status && (
                <div className="flex flex-col pt-6 pb-2">
                  {order.status === "packed" && (
                    <span className="font-bold text-xs px-2 bg-orange-300 w-min rounded-xl text-orange-700">
                      {order.status.toLocaleUpperCase()}
                    </span>
                  )}
                  {order.status === "sent" && (
                    <span className="font-bold text-xs px-2 bg-green-300 w-min rounded-xl text-green-700">
                      {order.status.toLocaleUpperCase()}
                    </span>
                  )}
                  {order.status === "canceled" && (
                    <span className="font-bold text-xs px-2 bg-red-300 w-min rounded-xl text-red-700">
                      {order.status.toLocaleUpperCase()}
                    </span>
                  )}
                  {order.status === "pending" && (
                    <span className="font-bold text-xs px-2 bg-gray-300 w-min rounded-xl text-gray-700">
                      {!order.vorkasse ? (
                        <p>PENDING</p>
                      ) : (
                        <p>VORKASSE</p>
                      )}
                    </span>
                  )}
                  {order.status === "picked" && (
                    <span className="font-bold text-xs px-2 bg-yellow-300 w-min rounded-xl text-yellow-700">
                      {order.status.toLocaleUpperCase()}
                    </span>
                  )}
                  {order.status === "returned" && (
                    <span className="font-bold text-xs px-2 bg-blue-300 w-min rounded-xl text-blue-700">
                      {order.status.toLocaleUpperCase()}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="">
            <button
              onClick={openModal}
              data-modal-target="default-modal"
              data-modal-toggle="default-modal"
              className="absolute top-6 right-6 hover:bg-sidebarGrayLight-700 font-medium text-sidebarGrayLight-900 dark:text-sidebarGrayLight-800 rounded-lg px-2 py-2 text-center dark:hover:bg-sidebarGray-700"
              type="button"
            >
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z"
                  fill="currentColor"
                  fillRule="evenodd"
                  clipRule="evenodd"
                ></path>
              </svg>
            </button>
            <div
              ref={modalRef}
              id="default-modal"
              aria-hidden="true"
              className="hidden absolute top-4 right-4 z-50 justify-center items-center w-full"
            >
              <div className="relative p-4 w-max max-h-full">
                <div className="relative bg-white rounded-lg shadow dark:bg-sidebarGray-700">
                  <div className="flex items-center justify-between p-2 border-b rounded-t dark:border-gray-600">
                    <p className="text-gray-950 dark:text-gray-50 pl-4 text-lg">
                      Bestelldetails kopieren
                    </p>
                    <button
                      onClick={closeModal}
                      type="button"
                      className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                      data-modal-hide="default-modal"
                    >
                      <svg
                        className="w-5 h-5"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 14"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                        />
                      </svg>
                      <span className="sr-only">Close modal</span>
                    </button>
                  </div>
                  <ul className="p-1 md:p-2 space-y-1">
                    <li
                      className="flex items-center justify-start gap-4 hover:bg-sidebarGrayLight-700 dark:hover:bg-sidebarGray-800 hover:cursor-pointer  px-4 py-1 rounded-lg"
                      onClick={() => {
                        if (typeof order.orderNumber === "string") {
                          navigator.clipboard.writeText(order.orderNumber);
                          toggleToast();
                          closeModal();
                        }
                      }}
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V4.00002H5.5C4.67158 4.00002 4 4.67159 4 5.50002V12.5C4 13.3284 4.67158 14 5.5 14H12.5C13.3284 14 14 13.3284 14 12.5V5.50002C14 4.67159 13.3284 4.00002 12.5 4.00002H11V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM5 5.50002C5 5.22388 5.22386 5.00002 5.5 5.00002H12.5C12.7761 5.00002 13 5.22388 13 5.50002V12.5C13 12.7762 12.7761 13 12.5 13H5.5C5.22386 13 5 12.7762 5 12.5V5.50002Z"
                          fill="currentColor"
                          fillRule="evenodd"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      <div className="flex items-center justify-center text-sm 2xl:text-base">
                        <p>Bestellnummer:&nbsp;</p>
                        <p>{order.orderNumber}</p>
                      </div>
                    </li>
                    <li
                      className="flex items-center justify-start gap-4 hover:bg-sidebarGrayLight-700 dark:hover:bg-sidebarGray-800 hover:cursor-pointer  px-4 py-1 rounded-lg"
                      onClick={() => {
                        if (typeof order.createdAt.toString() === "string") {
                          navigator.clipboard.writeText(
                            order.createdAt.toString()
                          );
                          toggleToast();
                          closeModal();
                        }
                      }}
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V4.00002H5.5C4.67158 4.00002 4 4.67159 4 5.50002V12.5C4 13.3284 4.67158 14 5.5 14H12.5C13.3284 14 14 13.3284 14 12.5V5.50002C14 4.67159 13.3284 4.00002 12.5 4.00002H11V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM5 5.50002C5 5.22388 5.22386 5.00002 5.5 5.00002H12.5C12.7761 5.00002 13 5.22388 13 5.50002V12.5C13 12.7762 12.7761 13 12.5 13H5.5C5.22386 13 5 12.7762 5 12.5V5.50002Z"
                          fill="currentColor"
                          fillRule="evenodd"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      <div className="flex items-center justify-center">
                        <p>Bestelldatum:&nbsp;</p>
                        <p>{order.createdAt.toString()}</p>
                      </div>
                    </li>
                    <li
                      className="flex items-center justify-start gap-4 hover:bg-sidebarGrayLight-700 dark:hover:bg-sidebarGray-800 hover:cursor-pointer px-4 py-1 rounded-lg"
                      onClick={() => {
                        if (typeof order.status === "string") {
                          navigator.clipboard.writeText(order.status);
                          toggleToast();
                          closeModal();
                        }
                      }}
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V4.00002H5.5C4.67158 4.00002 4 4.67159 4 5.50002V12.5C4 13.3284 4.67158 14 5.5 14H12.5C13.3284 14 14 13.3284 14 12.5V5.50002C14 4.67159 13.3284 4.00002 12.5 4.00002H11V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM5 5.50002C5 5.22388 5.22386 5.00002 5.5 5.00002H12.5C12.7761 5.00002 13 5.22388 13 5.50002V12.5C13 12.7762 12.7761 13 12.5 13H5.5C5.22386 13 5 12.7762 5 12.5V5.50002Z"
                          fill="currentColor"
                          fillRule="evenodd"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      <div className="flex items-center justify-center">
                        <p>Bestellstatus:&nbsp;</p>
                        <p>{order.status}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full h-full border-sidebarGrayLight-800 dark:border-gray-700 flex flex-col items-start justify-start">
          <div className="grid grid-cols-1 2xl:grid-cols-2 pt-6 pb-6 pr-6 gap-8">
            {order.products.map((product, index) => (
              <div
                key={index}
                className="pl-4 flex items-start justify-start gap-8"
              >
                {product.mainImage ? (
                  <img
                    src={`data:image/jpeg;base64,${product.mainImage}`}
                    alt={product.name}
                    className="w-36 h-36 rounded-lg"
                  />
                ) : (
                  <div className="flex items-center justify-center min-w-36 min-h-36 bg-gray-300 rounded-lg dark:bg-gray-700">
                    <svg
                      className="w-10 h-10 text-gray-200 dark:text-gray-600"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 18"
                    >
                      <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                    </svg>
                  </div>
                )}
                {/* )} */}
                <div className="flex flex-col items-start justify-start text-sm 2xl:text-base">
                  <div className="product-title">{product.name}</div>
                  {/* {product.dimensions.map(
                    (
                      dimension: {
                        type:
                          | string
                          | number
                          | boolean
                          | React.ReactElement<
                              any,
                              string | React.JSXElementConstructor<any>
                            >
                          | Iterable<React.ReactNode>
                          | React.ReactPortal
                          | null
                          | undefined;
                        value:
                          | string
                          | number
                          | boolean
                          | React.ReactElement<
                              any,
                              string | React.JSXElementConstructor<any>
                            >
                          | Iterable<React.ReactNode>
                          | React.ReactPortal
                          | null
                          | undefined;
                      },
                      dimIndex: React.Key | null | undefined
                    ) => (
                      <div key={dimIndex} className="product-dimension">
                        {dimension.type}: {dimension.value}
                      </div>
                    )
                  )} */}
                  <div className="flex flex-col items-start justify-start text-sm 2xl:text-base">
                    <span className="text-sm text-sidebarGray-500">
                      Artikelnummer:{" "}
                    </span>
                    {product.articleNr}
                  </div>
                  <div className="flex flex-col items-start justify-start text-sm 2xl:text-base">
                    <span className="text-sm text-sidebarGray-500">EAN: </span>
                    {product.ean}
                  </div>
                  <div className="flex flex-col items-start justify-start text-sm 2xl:text-base">
                    <span className="text-sm text-sidebarGray-500">
                      VK-Preis:{" "}
                    </span>
                    <span className="font-bold">
                      {formatPrice(product.price.toString())}€
                    </span>
                  </div>
                  <div className="flex flex-col items-start justify-start text-sm 2xl:text-base">
                    <span className="text-sm text-sidebarGray-500">
                      Artikel:{" "}
                    </span>
                    <span className="font-bold">{product.quantity}</span>
                  </div>
                  {product?.quantity && product?.quantity > 1 ? (
                    <div className="flex flex-col items-start justify-start text-sm 2xl:text-base">
                      <span className="text-sm text-sidebarGray-500">
                        Anzahl:{" "}
                      </span>
                      {product.quantity}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="relative p-6 w-full flex items-end justify-end">
            {renderButtons()}
          </div>
          {location.pathname != "/webshop/historie" &&
            location.pathname != "/webshop/eingang" &&
            location.pathname != "/webshop/retouren" && (
              <div className="group flex flex-col items-center justify-center">
                <button
                  data-tooltip-target="tooltip-default"
                  onClick={() => handleMoveOrderToPending?.(order.orderId)}
                  className="absolute top-6 right-6 flex items-center justify-center text-gray-50 bg-blue-400 dark:bg-sidebarGray-700 hover:bg-blue-500 dark:hover:bg-sidebarGray-500 rounded-lg p-2 gap-2 hover:peer-[visible]:"
                >
                  {isLoadingRevert ? (
                    <MoonLoader color="rgba(215, 215, 215, 1)" size={15} />
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.85355 2.14645C5.04882 2.34171 5.04882 2.65829 4.85355 2.85355L3.70711 4H9C11.4853 4 13.5 6.01472 13.5 8.5C13.5 10.9853 11.4853 13 9 13H5C4.72386 13 4.5 12.7761 4.5 12.5C4.5 12.2239 4.72386 12 5 12H9C10.933 12 12.5 10.433 12.5 8.5C12.5 6.567 10.933 5 9 5H3.70711L4.85355 6.14645C5.04882 6.34171 5.04882 6.65829 4.85355 6.85355C4.65829 7.04882 4.34171 7.04882 4.14645 6.85355L2.14645 4.85355C1.95118 4.65829 1.95118 4.34171 2.14645 4.14645L4.14645 2.14645C4.34171 1.95118 4.65829 1.95118 4.85355 2.14645Z"
                        fill="currentColor"
                        fillRule="evenodd"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  )}
                </button>
                <div className="absolute top-[26px] right-16 hidden group-hover:block w-auto">
                  <div className="bottom-full right-0 rounded bg-blue-400 dark:bg-sidebarGray-700 px-4 py-1 text-sm text-white whitespace-nowrap">
                    Bestellung erneut erfassen
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
      <div
        ref={toastRef}
        id="toast-success"
        className="fixed right-4 bottom-4 z-50 hidden items-center w-1/2 p-4 text-gray-500 bg-white rounded-lg shadow dark:text-gray-400 dark:bg-sidebarGray-700"
        role="alert"
      >
        <div className="flex items-center justify-between">
          <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-green-500 bg-green-100 rounded-lg dark:bg-green-800 dark:text-green-200">
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
            </svg>
            <span className="sr-only">Check icon</span>
          </div>
          <div className="ms-3 text-base font-normal">
            Erfolgreich der Zwischenablage hinzugefügt.
          </div>
          <button
            onClick={toggleToast}
            type="button"
            className="ms-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex items-center justify-center h-8 w-8 dark:text-gray-500 dark:hover:text-white dark:bg-sidebarGray-800 dark:hover:bg-sidebarGray-900"
            data-dismiss-target="#toast-success"
            aria-label="Close"
          >
            <span className="sr-only">Close</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
          </button>
        </div>
      </div>
      <div
        ref={modalAcceptRef}
        id="default-modal"
        aria-hidden="true"
        className="hidden overflow-y-auto overflow-x-hidden fixed bg-black/75 right-0 left-0 bottom-[50%] z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
      >
        <div className="relative p-4 w-full max-w-2xl max-h-full mx-auto">
          <div className="relative bg-white rounded-lg shadow dark:bg-sidebarGray-800">
            <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                Bestellung abschließen
              </h3>
              <button
                onClick={closeModalAccept}
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                data-modal-hide="default-modal"
              >
                <svg
                  className="w-5 h-5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <div className="p-4 md:p-5 space-y-4">
              <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                Sind Sie sicher, dass Sie diese Bestellung endgültig abschließen
                wollen?
              </p>
              <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                Dieser Vorgang ist nicht umkehrbar.
              </p>
            </div>
            <div className="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
              <button
                disabled={isLoadingPickUp}
                onClick={handleCompleteAndClose}
                data-modal-hide="default-modal"
                type="button"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                {isLoadingPickUp ? (
                  <MoonLoader color="rgba(215, 215, 215, 1)" size={15} />
                ) : (
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                )}
                Bestellung abschließen
              </button>
              <button
                onClick={closeModalAccept}
                data-modal-hide="default-modal"
                type="button"
                className="ms-3 text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
              >
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        ref={modalReturnDenyRef}
        id="default-modal"
        aria-hidden="true"
        className="hidden overflow-y-auto overflow-x-hidden fixed bg-black/75 right-0 left-0 bottom-[50%] z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
      >
        <div className="relative p-4 w-full max-w-2xl max-h-full mx-auto">
          <div className="relative bg-white rounded-lg shadow dark:bg-sidebarGray-800">
            <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                Retoure ablehnen
              </h3>
              <button
                onClick={closeModalReturnDeny}
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                data-modal-hide="default-modal"
              >
                <svg
                  className="w-5 h-5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <div className="p-4 md:p-5 space-y-4">
              <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                Wählen Sie einen Zustand für die Retoure aus.
              </p>
              <Menu as="div" className="relative inline-block text-left w-full">
                <Menu.Button
                  className="inline-flex w-full justify-between gap-x-1.5 rounded-md bg-white dark:bg-sidebarGray-700 px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-400 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  aria-placeholder="Retourengrund..."
                >
                  {selectedCondition ? (
                    selectedCondition
                  ) : (
                    <span>Zustand des Retoure</span>
                  )}
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z"
                      fill="currentColor"
                      fillRule="evenodd"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </Menu.Button>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-max origin-top-right divide-y divide-sidebarGray-500 rounded-md bg-white dark:bg-sidebarGray-700 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() => handleSelectCondition("A")}
                        >
                          A - Originalverpackung
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() => handleSelectCondition("B")}
                        >
                          B - unbenutzt
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() => handleSelectCondition("C")}
                        >
                          C - leichte Gebrauchsspuren
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() => handleSelectCondition("D")}
                        >
                          D - schwere Gebrauchsspuren
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() => handleSelectCondition("E")}
                        >
                          <span>E - Fehler(unvollständig)</span>
                        </a>
                      )}
                    </Menu.Item>
                  </Menu.Items>
                </Transition>
              </Menu>
              <p className="pt-8 text-base leading-relaxed text-gray-500 dark:text-gray-400">
                Geben Sie einen Grund für die Verweigerung an.
              </p>
              <Menu as="div" className="relative inline-block text-left w-full">
                <div>
                  <Menu.Button
                    className="inline-flex w-full justify-between gap-x-1.5 rounded-md bg-white dark:bg-sidebarGray-700 px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-400 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    aria-placeholder="Retourengrund..."
                  >
                    {selectedReason ? (
                      selectedReason
                    ) : (
                      <span>Grund der Ablehnung</span>
                    )}
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z"
                        fill="currentColor"
                        fillRule="evenodd"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-max origin-top-right divide-y divide-sidebarGray-500 rounded-md bg-white dark:bg-sidebarGray-700 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() =>
                            handleSelectReason(
                              "Artikel entspricht nicht der Rückgaberichtlinie (z.B. Rückgabefrist überschritten)"
                            )
                          }
                        >
                          <span>
                            Artikel entspricht nicht der Rückgaberichtlinie
                            (z.B. Rückgabefrist überschritten)
                          </span>
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() =>
                            handleSelectReason(
                              "Artikel wurde beschädigt zurückgesandt"
                            )
                          }
                        >
                          <span>Artikel wurde beschädigt zurückgesandt</span>
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() =>
                            handleSelectReason("Artikel ist unvollständig")
                          }
                        >
                          <span>Artikel ist unvollständig</span>
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() =>
                            handleSelectReason("Falscher Artikel zurückgesandt")
                          }
                        >
                          <span>Falscher Artikel zurückgesandt</span>
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() =>
                            handleSelectReason(
                              "Kein Kaufnachweis oder keine Bestellbestätigung beigefügt"
                            )
                          }
                        >
                          <span>
                            Kein Kaufnachweis oder keine Bestellbestätigung
                            beigefügt
                          </span>
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() =>
                            handleSelectReason(
                              "Verpackung fehlt oder ist beschädigt"
                            )
                          }
                        >
                          <span>Verpackung fehlt oder ist beschädigt</span>
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() =>
                            handleSelectReason(
                              "Artikel gehört nicht zum Sortiment des Händlers (Fehllieferung)"
                            )
                          }
                        >
                          <span>
                            Artikel gehört nicht zum Sortiment des Händlers
                            (Fehllieferung)
                          </span>
                        </a>
                      )}
                    </Menu.Item>
                    <Menu.Item>
                      {({ active }) => (
                        <a
                          href="#"
                          className={classNames(
                            active
                              ? "bg-gray-100 dark:bg-sidebarGray-500 text-gray-900 dark:text-gray-50"
                              : "text-gray-900 dark:text-gray-50",
                            "block px-4 py-2 text-sm"
                          )}
                          onClick={() =>
                            handleSelectReason(
                              "Gebrauchsspuren, die über das normale Auspacken und Testen des Produkts hinausgehen"
                            )
                          }
                        >
                          <span>
                            Gebrauchsspuren, die über das normale Auspacken und
                            Testen des Produkts hinausgehen
                          </span>
                        </a>
                      )}
                    </Menu.Item>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
            <div className="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
              <button
                onClick={handleReturnDenyAndClose}
                data-modal-hide="default-modal"
                type="button"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Retoure ablehnen
              </button>
              <button
                onClick={closeModalReturnDeny}
                data-modal-hide="default-modal"
                type="button"
                className="ms-3 text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
              >
                Abbrechen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderCardWebshop;
